import { AITrace } from "../models/aiTrace";
import axiosConfig from "./axiosConfig";

// Fetch the AI trace for the model call that decided what company a tenant label
// names. Returns null when no trace is available (a company identified before the
// trace was captured, or a trace not copied into a non-prod env).
//
// `companyName` is the tenant's DISPLAYED label; the backend normalises it to the
// storage key, so this deliberately does not mirror that normalisation here - one
// implementation of it, not two. `runId` is read off the row's own
// `tenantCommercial.identityTraceRunId` and is required.
const getCompanyIdentityTrace = async (
  authToken: string,
  companyName: string,
  runId: string
): Promise<AITrace | null> => {
  const { data } = await axiosConfig.get(`/leads/company-identity-trace`, {
    params: { companyName, runId },
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data?.trace ?? null;
};

export default getCompanyIdentityTrace;
